import { Pipe, PipeTransform } from '@angular/core';
import { DateFormate } from '@app/shared/constants/constant';
import { CommonService } from '@app/shared/services/common.service';
import * as moment from 'moment-timezone';
@Pipe({
    name: 'changeTime',
    standalone: false
})
export class DateFilterPipe implements PipeTransform {
  // required parameters date in utc format,type is utc or local and timezone
  constructor(private commonService: CommonService) { }
  private parseDateInput(date: any, timezone?: string): moment.Moment {
    const parsedDate = typeof date === 'string' ? date.replace(/^on\s+/i, '').trim() : date;
    const knownFormats = [
      moment.ISO_8601,
      'MMM DD, YYYY, HH:mm',
      'MMM D, YYYY, HH:mm',
      'MMMM DD, YYYY, HH:mm',
      'MMMM D, YYYY, HH:mm',
    ];

    if (timezone) {
      const strictTzParsed = moment.tz(parsedDate, knownFormats as any, true, timezone);
      if (strictTzParsed.isValid()) {
        return strictTzParsed;
      }
      return moment.tz(parsedDate, timezone);
    }

    const strictParsed = moment(parsedDate, knownFormats as any, true);
    if (strictParsed.isValid()) {
      return strictParsed;
    }
    return moment(parsedDate);
  }

  public transform(date?: any, type?: any, timezone?: any) {
    if (date === null || date === undefined || date === '') {
      return '';
    }
    // if local converting to the depart airport timezone format and diplaying
    // with user selected format if found
    const hasOnPrefix = typeof date === 'string' && date.startsWith('on');
    const parsedMoment = this.parseDateInput(date, timezone);
    const zonedMoment =
      timezone && typeof timezone === 'string'
        ? parsedMoment.clone().tz(timezone)
        : parsedMoment;

    if (!zonedMoment || !zonedMoment.isValid()) {
      return '';
    }
    if (type != 'UTC') {
      if (this.commonService.userFormat.TimeFormat != '') {
        const dateToTimezone =
          zonedMoment
            .format(this.commonService.userFormat.TimeFormat);
        return hasOnPrefix ? 'on ' + dateToTimezone : dateToTimezone;
      } else {
        const dateToTimezone =
          zonedMoment
            .format(DateFormate.dispalyMinDate);
        return hasOnPrefix ? 'on ' + dateToTimezone : dateToTimezone;
      }
    } else {
      const dateToTimezone =
        zonedMoment
          .utc()
          .format(DateFormate.displayDateMinFormate) + 'Z';
      return hasOnPrefix ? 'on ' + dateToTimezone : dateToTimezone;
    }
  }
}
